import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  Calendar as CalendarView,
  Dashboard as DashboardView,
  ProductList as ProductListView,
  MembershipList as MembershipListView,
  Memberships as MembershipsView,
  MemberValidation as MembershipsMemberValidateView,
  GiftCardsAreasList as GiftCardsAreasListView,
  MainGiftCards as MainGiftCardsView,
  FindMyBooking as FindMyBookingView,
  ManageBooking as ManageBookingView,
  ConfimBookingChanges as ConfimBookingChangesView,
  ModifyTicketsAddons as ModifyTicketsAddonsView,
  ManageCheckout as ManageCheckoutView,
  UserList as UserListView,
  Typography as TypographyView,
  Icons as IconsView,
  Account as AccountView,
  Settings as SettingsView,
  NotFound as NotFoundView,
  Checkout as CheckoutView,
  GATickets as GATickets,
  OrderLocationScreen as FoodOrderLocationScreen,
  OrderLocationTab as OrderLocationTabScreen,
  OrderMenu as OrderMenuScreen,
  OrderSubMenu as OrderSubMenuScreen,
  OrderItemsReview as OrderItemsReviewScreen,
  DonationAreas as DonationAreasView,
  DonationProducts as DonationProductsView,
  ManageMultipleBookings as ManageMultipleBookingsView,
} from './views';

const Routes = () => {
  return (
    <Switch>

      <Redirect
        exact
        from="/"
        to="/products"
      />

      <RouteWithLayout
        component={CalendarView}
        exact
        layout={MainLayout}
        path="/calendar/:id"
      />

      <RouteWithLayout
        component={CalendarView}
        exact
        layout={MainLayout}
        path="/calendar/Area/:id"
      />

      <RouteWithLayout
        component={GATickets}
        exact
        layout={MainLayout}
        path="/gatickets/"
      />

      <RouteWithLayout
        component={GATickets}
        exact
        layout={MainLayout}
        path="/gatickets/Area/:id"
      />

      <RouteWithLayout
        component={FoodOrderLocationScreen}
        exact
        layout={MainLayout}
        path="/orderlocation/"
      />

      <RouteWithLayout
        component={FoodOrderLocationScreen}
        exact
        layout={MainLayout}
        path="/orderlocation/Area/:id"
      />

      <RouteWithLayout
        component={OrderLocationTabScreen}
        exact
        layout={MainLayout}
        path="/orderlocationtab/:name"
      />

      <RouteWithLayout
        component={OrderMenuScreen}
        exact
        layout={MainLayout}
        path="/ordermenu/:id"
      />

      <RouteWithLayout
        component={OrderSubMenuScreen}
        exact
        layout={MainLayout}
        path="/ordersubmenu/:name"
      />

      <RouteWithLayout
        component={OrderItemsReviewScreen}
        exact
        layout={MainLayout}
        path="/revieworderproducts"
      />

      <RouteWithLayout
        component={ProductListView}
        exact
        layout={MainLayout}
        path="/products"
      />

      <RouteWithLayout
        component={ProductListView}
        exact
        layout={MainLayout}
        path="/products?DisplayAreaIds:displayareaids"
      />

      <RouteWithLayout
        component={GiftCardsAreasListView}
        exact
        layout={MainLayout}
        path="/giftcards"
      />

      <RouteWithLayout
        component={MainGiftCardsView}
        exact
        layout={MainLayout}
        path="/giftcards/:id"
      />

      <RouteWithLayout
        component={MembershipsView}
        exact
        layout={MainLayout}
        path="/memberships/join/:id"
      />

      <RouteWithLayout
        component={MembershipsView}
        exact
        layout={MainLayout}
        path="/memberships/renew/:id"
      />

      <RouteWithLayout
        component={MembershipsMemberValidateView}
        exact
        layout={MainLayout}
        path="/memberships/membervalidate"
      />

      <RouteWithLayout
        component={MembershipListView}
        exact
        layout={MainLayout}
        path="/memberships"
      />

      <RouteWithLayout
        component={FindMyBookingView}
        exact
        layout={MainLayout}
        path="/findmybooking"
      />

      <RouteWithLayout
        component={FindMyBookingView}
        exact
        layout={MainLayout}
        path="/findmybooking/:name/:email/:bookingid"
      />

      <RouteWithLayout
        component={FindMyBookingView}
        exact
        layout={MainLayout}
        path="/findmybooking?Name:name&email:email&bookingID:bookingid"
      />

      <RouteWithLayout
        component={ManageBookingView}
        exact
        layout={MainLayout}
        path="/managebooking"
      />

      <RouteWithLayout
        component={ManageMultipleBookingsView}
        exact
        layout={MainLayout}
        path="/managemultiplebookings"
      />

      <RouteWithLayout
        component={ConfimBookingChangesView}
        exact
        layout={MainLayout}
        path="/confimbookingchanges"
      />

      <RouteWithLayout
        component={ModifyTicketsAddonsView}
        exact
        layout={MainLayout}
        path="/modifytickets"
      />

      <RouteWithLayout
        component={ManageCheckoutView}
        exact
        layout={MainLayout}
        path="/managecheckout"
      />
      <RouteWithLayout
        component={DonationAreasView}
        exact
        layout={MainLayout}
        path="/donationareas"
      />

      <RouteWithLayout
        component={DonationProductsView}
        exact
        layout={MainLayout}
        path="/donation/"
      />

      <RouteWithLayout
        component={DonationProductsView}
        exact
        layout={MainLayout}
        path="/donation/Area/:id"
      />

      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MainLayout}
        path="/not-found"
      />
      <RouteWithLayout
        component={CheckoutView}
        exact
        layout={MainLayout}
        path="/checkout"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
